<div v-if="is_checkout" class="p-4 rounded-4 mb-4">
  <h5 class="fw-semibold mb-2">Delivery Pick Up Point</h5>
  <div v-if="selected_pickup_point_name" class="d-flex justify-content-between">
    <p class="fw-semibold">Selected Pickup Point:</p>
    <p>
      <i class="bi bi-geo-alt"></i> {{ selected_pickup_point_name }} - {{
      selected_pickup_point }}
    </p>
  </div>
  <div class="pargo-map-container">
    <iframe
      :src="pargo_map_url"
      width="100%"
      height="500"
      allowfullscreen
    ></iframe>
  </div>
</div>

<div v-else >
  <h5 class="mb-3">Select Drop-off Point</h5>
  <div v-if="selected_drop_off_point_name" class="d-flex justify-content-between">
    <p class="fw-semibold">Selected Drop-off Point:</p>
    <p>
      <i class="bi bi-geo-alt"></i> {{ selected_drop_off_point_name }} - {{
      selected_drop_off_point }}
    </p>
  </div>
  <div class="pargo-map-container">
    <iframe
      :src="pargo_map_url"
      width="100%"
      height="500"
      allowfullscreen
    ></iframe>
  </div>
</div>
